import React, { FC, useEffect, useState } from "react";
import { ActivityLog, LineHandling, Nomination } from "../../models";
import { connect } from "react-redux";
import { DefaultButton, Dialog, Dropdown } from "@fluentui/react";
import { IDropdownOption, ISelectableOption } from "@fluentui/react";
import { last6Digits } from "../../services/Helper";
import {
  DatePicker,
  DialogFooter,
  DialogType,
  Icon,
  MaskedTextField,
  Spinner,
  SpinnerSize,
  Stack,
  TeachingBubble,
  Text,
  TextField,
  MessageBar,
  MessageBarType,
} from "office-ui-fabric-react";
import { mergeStyleSets, PrimaryButton } from "office-ui-fabric-react";
import { Post } from "../../api/apiUtils";
import { State } from "../../store";
import { useHistory } from "react-router";
import clsx from "clsx";
import moment from "moment";
import queryString from "query-string";
import * as ActivityLogStore from "../../store/ActivityLogsStore";
import * as GeneralStore from "../../store/GeneralStore";
import * as LineHandlingStore from "../../store/LineHandlingStore";
import * as ProcessFlowConfigStore from "../../store/ProcessFlowConfigStore";
import * as WorkPacketeStore from "../../store/WorkPacketStore";
import ApiSpinner from "../common/ApiSpinner";
import { loadPdfDoc } from "../../services/PdfDocumentService";
import Axios from "axios";
import { AuthProvider } from "../../AuthProvider";
import { Get, Delete } from "../../api/apiUtils";

type IProps = ActivityLogStore.ActivityLogsState &
  GeneralStore.GeneralState &
  LineHandlingStore.LineHandlingState &
  ProcessFlowConfigStore.ProcessFlowConfigState &
  WorkPacketeStore.WorkPacketState &
  typeof ActivityLogStore.actionCreators &
  typeof LineHandlingStore.actionCreators &
  typeof ProcessFlowConfigStore.actionCreators &
  typeof WorkPacketeStore.actionCreators;

interface IActivity {
  lineHandlingNo: string;
  nominationNo?: string;
  state: string;
  startDescription?: string;
  startTime?: string;
  startActivityId?: number | undefined;
  endDescription: string;
  endTime: string;
  endActivityId: number;
  order: number;
}

type IEditTimestampModel = {
  startActivityId?: number;
  finishedActivityId: number;
  startedOn: string;
  finishedOn: string;
};

const classes = mergeStyleSets({
  container: {
    height: "100%",
    padding: 12,
    //color: "#7C7777"
  },
  innerContainer: {
    background: "#FFFFFF",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  lowerContainer: {
    flexGrow: 1,
    overflow: "auto",
  },
  modalContainer: { width: 650 },
  lineHandlingRow: {
    display: "flex",
    gap: 8,
    padding: "12px 12px 6px 12px",
    alignItems: "center",
  },
  vesselText: {
    fontWeight: "bold",
    color: "#00447e",
  },
  lineHandlingDRow: {
    flexGrow: 1,
    display: "flex",
    gap: 90,
    alignItems: "center",
    justifyContent: "center",
  },
  dt: {
    display: "inline",
  },
  dd: {
    marginBottom: "unset !important",
  },
  button: {
    width: 100,
    height: 40,
    background: "var(--primary-500)",
    selectors: {
      [":hover"]: {
        backgroundColor: "var(--primary-400)"
      }
    }
  },
  stateRow: {
    padding: "6px 12px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  stateButtons: {
    display: "flex",
    flexDirection: "row",
    gap: 8,
    flexGrow: 1,
  },
  stateButton: {
    padding: "10px 24px",
    cursor: "pointer",
    fontSize: 14,
    background: "var(--grey-050)",
    borderRadius: 4,
    selectors: {
      [":hover"]: {
        backgroundColor: "var(--primary-500)",
        color: "var(--white-000)"
      }
    }
  },
  stateButtonSel: {
    padding: "10px 24px",
    fontWeight: "bold",
    color: "var(--white-000)",
    borderRadius: 4,
    backgroundColor: "var(--primary-500)",
    fontSize: 14,
  },
  inputGroup: {
    display: "flex",
    flexDirection: "row",
    gap: 8,
  },
  inputField: {
    display: "inline",
  },
  columnHeader: {
    padding: 12,
    fontSize: 14,
    fontWeight: "bold",
    borderTop: "1px solid var(--grey-200)",
    borderBottom: "1px solid var(--grey-200)",
  },
  detailsDiv: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    "-webkit-line-clamp": "1",
    display: "-webkit-box",
    "-webkit-box-orient": "vertical",
  },
  dataRow: {
    borderBottom: "1px solid var(--grey-200)",
    padding: 12,
  },
  textBoxError: {
    border: "1px solid rgb(168, 0, 0)",
  },
  textBoxEdited: {
    backgroundColor: "#DBEFDC",
    border: "1px solid var(--grey-200)",
  },
  iconStyle: {
    width: 32,
    height: 32,
    color: "rgb(168, 0, 0)",
  },
  noItem: {
    textAlign: "center",
    color: "#c4c4c4",
    margin: 24,
  },
  primaryBtn: {
    background: "var(--primary-500)",
    selectors: {
      [":hover"]: {
        backgroundColor: "var(--primary-400)"
      }
    }
  }
});

let invalidActivities: number[] = [];
let errMessage: string;

const ReviewSoF: FC<IProps> = (props: IProps) => {
  const [isReadonly, setIsReadonly] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [reason, setReason] = useState<string>();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [departureDate, setDepartureDate] = useState<string>();
  const [selectedNomination, setSelectedNomination] = useState<string>();
  const [groupedActivities, setGroupedActivities] = useState<IActivity[]>([]);
  const [nominationOptions, setNominationOptions] = useState<IDropdownOption[]>(
    []
  );
  const history = useHistory();
  const [errorMessage, setErrorMessage] = useState<string>();

  const approveDialogProps = {
    type: DialogType.close,
    title: "Approve Line Handling",
    closeButtonAriaLabel: "Close",
    subText:
      invalidActivities.length > 0
        ? "Errors must be fixed before line handling can be approved."
        : "Approve the line handling and all pegged nominations? Once approved, the nominations will be locked and visible on the Reports page.",
  };

  const revertDialogProps = {
    type: DialogType.close,
    title: "Edit Line Handling",
    closeButtonAriaLabel: "Close",
    className: "dialog-revert",
    subText: `Are you sure you want to make changes? Doing so will unlock the line handling and it's pegged nominations.`,
  };

  const groupBy = (array: ActivityLog[], f: any) => {
    var groups: any = {};
    array.forEach((o) => {
      var group = JSON.stringify(f(o));
      groups[group] = groups[group] || [];
      groups[group].push(o);
    });
    return Object.keys(groups).map((group) => groups[group]);
  };

  const renderDropdown = (option: ISelectableOption | undefined) => {
    return (
      <div>
        <span style={{ fontWeight: "bold" }}>{option!.text}</span>
        <br />
        <span className={classes.detailsDiv}>{option!.title}</span>
      </div>
    );
  };

  const onDropdownChanged = (_event: any, option: any) => {
    if (option && props.lineHandling.result) {
      if (option.key !== props.lineHandling.result.lineHandlingNo) {
        const nom = props.lineHandling.result.nominations.find(
          (f) => f.nominationNo === option.key
        );
        if (nom && nom.processFlowConfigId) {
          props.setActiveConfig(
            nom.processFlowConfigId,
            nom.processFlowConfigVersion
          );
        }
      } else {
        if (props.lineHandling.result.processFlowConfigId) {
          props.setSelectedState("");
          props.setActiveConfig(
            props.lineHandling.result.processFlowConfigId,
            props.lineHandling.result.processFlowConfigVersion
          );
        }
      }
      setSelectedNomination(option.key);
    }
  };

  const loadFiles = async (lineHandlingNo: string) => {
    const response = await Get(
      `/api/Attachment/marine/reports/${lineHandlingNo}`
    );
    const resultRes = await response.json();
    const attachments = await Promise.all(
      (resultRes || []).map(async (file: any) => {
        //const base64Data = await getBase64FromUrl(file.url);
        return {
          attachmentId: file.attachmentId,
          //previewBase64: base64Data,
          previewBlob: file.url,
          name: file.fileName,
          size: file.fileSize,
          canDelete: file.canDelete,
        };
      })
    );
    return attachments;
  };

  const uploadDocuments = async (lineHandlingNo: string) => {
    const token = await AuthProvider.getIdToken();
    const source = Axios.CancelToken.source();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token.idToken.rawIdToken}`,
      },
      cancelToken: source.token,
    };

    //get all attachments
    const files = await loadFiles(lineHandlingNo);

    //delete all attachments
    files?.forEach(async (file: any) => {
      await Delete(`/api/Attachment/${file.attachmentId}`);
    });

    //reupload
    const documents = props.workPacketDocuments.result?.filter(
      (f) => f.workPacketType > 1
    );

    documents?.forEach(async (doc) => {
      const workPacket = props.workPackets.result?.filter(
        (f) => f.id === doc.workPacketId
      );

      const pdfFile =
        workPacket === undefined ? "" : workPacket[0].layouts[0].pdfFile;

      const pdfDoc = await loadPdfDoc(
        pdfFile,
        lineHandlingNo,
        doc.nominationNo,
        doc.workPacketType === 3 ? doc.id : undefined,
        props.lineHandling,
        props.workPacketValues
      );
      if (pdfDoc) {
        const base64String = await pdfDoc.saveAsBase64({ dataUri: true });

        const last2 = base64String.slice(-2);
        const fileSize =
          base64String.length * (3 / 4) - (last2 === "==" ? 2 : 1);

        const payload = {
          fileName: doc.name,
          content: base64String,
          fileSize: fileSize,
        };
        await Axios.post(
          `/api/Attachment/marine/reports/${lineHandlingNo}`,
          JSON.stringify(payload),
          config
        );
      }
    });
  };

  const onDialogSubmit = () => {
    if (isReadonly) {
      setShowConfirmModal(false);
      setShowReasonModal(true);
    } else {
      approveLineHandling();
    }
  };

  const approveLineHandling = async () => {
    try {
      const { result } = props.lineHandling;
      //var timeZone = moment.tz.guess();
      if (result) {
        setIsLoading(true);
        const response = await Post(
          `/api/v1.5/linehandling/${result?.lineHandlingNo}/activities/approved`,
          //JSON.stringify({ timeZone })
          null
        );
        setIsLoading(false);
        setShowConfirmModal(false);

        if (response.ok) {
          await uploadDocuments(result?.lineHandlingNo);
          setTimeout(async () => {
            var lineHandling = (await response.json()) as LineHandling;
            props.setLineHandling(lineHandling);
          }, 300);
        }
      }
    } catch {
      setErrorMessage("Unable to save changes. Please try to reconnect.");

      setIsLoading(false);
    }
  };

  const makeChanges = async (event: any) => {
    try {
      event.preventDefault();
      const { result } = props.lineHandling;
      setIsLoading(true);
      if (result) {
        const response = await Post(
          `/api/v1.5/linehandling/${result.lineHandlingNo}/activities/unapproved`,
          JSON.stringify({ reason })
        );
        if (response.ok) {
          //get all attachments
          const files = await loadFiles(result.lineHandlingNo);

          //delete all attachments
          files?.forEach(async (file: any) => {
            await Delete(`/api/Attachment/${file.attachmentId}`);
          });

          setIsLoading(false);
          setShowReasonModal(false);
          setShowConfirmModal(false);
          setReason("");

          const lineHandling = (await response.json()) as LineHandling;
          props.setLineHandling(lineHandling);
        }
      }
    } catch {
      setErrorMessage("Unable to save changes. Please try to reconnect.");

      setIsLoading(false);
    }
  };

  const onEditTimestamp = (result: ActivityLog[]) => {
    props.insertActivityLogs(result);
  };

  const closeErrDialog = () => {
    errMessage = "";
  };

  useEffect(() => {
    const { search } = history.location;
    const q = queryString.parse(search.toLowerCase());
    const linehandlingno = q.linehandling as string | undefined;
    const nominationno = q.nomination as string | undefined;
    if (linehandlingno) {
      setSelectedNomination(linehandlingno.toUpperCase());
      if (props.processFlowConfigs.result === undefined) {
        props.getAllConfigs(true);
      }

      props.getActivityLogs(linehandlingno, () =>
        props.getLineHandling(linehandlingno, nominationno, false, true)
      );
      props.getWPValues(linehandlingno);
      props.getAllWorkPackets();
    } else {
      history.push("/nominations");
    }
  }, []);

  useEffect(() => {
    if (props.lineHandling.result) {
      var options: IDropdownOption[] = [];
      options.push({
        key: props.lineHandling.result.lineHandlingNo,
        text: `Line Handling # ${last6Digits(
          props.lineHandling.result.lineHandlingNo
        )}`,
        title: props.lineHandling.result.vesselName,
        selected: true,
      });

      props.lineHandling.result.nominations.map((nomination: Nomination) => {
        options.push({
          key: nomination.nominationNo,
          text: `Nomination # ${last6Digits(nomination.nominationNo)}`,
          title: `${nomination.product}`,
          selected: false,
        } as IDropdownOption);
        return options;
      });

      setIsReadonly(props.lineHandling.result.status !== 3);
      setNominationOptions(options);
    }
  }, [props.lineHandling]);

  useEffect(() => {
    if (props.activityLogs.result) {
      const grouped = groupBy(
        props.activityLogs.result.filter(
          (f) => f.status === 1 || f.status === 2
        ),
        (activityLog: ActivityLog) => [
          activityLog.nominationNo,
          activityLog.processStepId,
          activityLog.repetitionOrder,
        ]
      );

      const departureActivity = props.activityLogs.result.filter(
        (f) =>
          f.nominationNo === undefined &&
          f.description === "Departure" &&
          f.status === 2
      );
      if (departureActivity.length > 0) {
        setDepartureDate(
          moment
            .utc(`${departureActivity[0].logTime} UTC`)
            .local()
            .format("ll HH:mm")
        );
      }

      const result = grouped.map((items: ActivityLog[], index: number) => {
        const start = items.filter((f) => f.status === 1)[0];
        const end = items.filter((f) => f.status === 2)[0];
        const step = props.config?.steps.find(
          (f) => f.id === items[0].processStepId
        );

        return {
          lineHandlingNo: items[0].lineHandlingNo,
          nominationNo: items[0].nominationNo
            ? items[0].nominationNo
            : items[0].lineHandlingNo,
          state: items[0].state,
          endDescription: end && end.description,
          endActivityId: end && end.id,
          endTime: end && end.logTime,
          startDescription: start && start.description,
          startActivityId: start && start.id,
          startTime: start && start.logTime,
          order: step ? step.order : index + 1,
        } as IActivity;
      });

      if (result) {
        setGroupedActivities(result.sort((a, b) => a.order - b.order));
      }
    }
  }, [props.activityLogs]);

  useEffect(() => {
    if (!props.isMarineEditTimestampAllowed) {
      history.push("/nominations");
    }
  }, [props.isMarineEditTimestampAllowed]);

  useEffect(() => {
    if (
      props.config &&
      (props.selectedState === undefined ||
        props.selectedState === "" ||
        props.config.states.filter((f) => f.name === props.selectedState)
          .length === 0)
    ) {
      props.setSelectedState(props.config.states[0].name);
    }
  }, [props.config]);

  useEffect(() => {
    invalidActivities = [];
  }, [props.selectedState]);

  return (
    <div className={classes.container}>
      <Dialog
        hidden={!showConfirmModal}
        dialogContentProps={isReadonly ? revertDialogProps : approveDialogProps}
        styles={{ main: { width: 550 } }}
        onDismiss={() => setShowConfirmModal(false)}
      >
        {errorMessage && (
          <div style={{ marginTop: "10px" }}>
            <MessageBar
              messageBarType={MessageBarType.error}
              onDismiss={() => setErrorMessage(undefined)}
            >
              {errorMessage}
            </MessageBar>
          </div>
        )}
        {isReadonly && (
          <span className="msg">You must also make these changes in SAP.</span>
        )}
        <DialogFooter>
          <PrimaryButton
            onClick={onDialogSubmit}
            disabled={isLoading || invalidActivities.length > 0}
            className={classes.primaryBtn}
          >
            {isReadonly ? "Make changes" : "Approve"}
          </PrimaryButton>
          <DefaultButton
            onClick={() => setShowConfirmModal(false)}
            disabled={isLoading}
          >
            Go back
          </DefaultButton>
        </DialogFooter>
      </Dialog>
      <Dialog
        dialogContentProps={{
          type: DialogType.close,
          title: "Edit Line Handling",
        }}
        hidden={!showReasonModal}
        onDismiss={() => setShowReasonModal(false)}
      >
        <form onSubmit={makeChanges}>
          <Stack>
            <p>Please enter a reason for making changes.</p>
            <TextField
              multiline
              disabled={isLoading}
              onChange={(_, value?: string) => setReason(value)}
              required
              value={reason}
              maxLength={1000}
            ></TextField>

            {errorMessage && (
              <div style={{ marginTop: "10px" }}>
                <MessageBar
                  messageBarType={MessageBarType.error}
                  onDismiss={() => setErrorMessage(undefined)}
                >
                  {errorMessage}
                </MessageBar>
              </div>
            )}
          </Stack>
          <DialogFooter>
            <PrimaryButton
              type="submit"
              disabled={
                isLoading || reason === undefined || reason.trim() === ""
              }
            >
              Confirm
            </PrimaryButton>
            <DefaultButton
              onClick={() => setShowReasonModal(false)}
              disabled={isLoading}
            >
              Cancel
            </DefaultButton>
          </DialogFooter>
        </form>
      </Dialog>

      <div className={classes.innerContainer}>
        <div>
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-md12">
                <div className={classes.lineHandlingRow}>
                  {(props.activityLogs.isLoading ||
                    props.lineHandling.isLoading) && (
                    <div className={classes.lineHandlingDRow}>&nbsp;</div>
                  )}
                  {props.lineHandling.result && (
                    <>
                      <div
                        className={`${props.lineHandling.result.vesselType.toLowerCase()}-icon`}
                      ></div>
                      <span className={classes.vesselText}>
                        {props.lineHandling.result.vesselName}
                      </span>
                    </>
                  )}

                  {props.lineHandling.result && (
                    <div className={classes.lineHandlingDRow}>
                      <span>
                        <dt className={classes.dt}>Line Handling: #</dt>
                        <dd className={classes.dd}>
                          {last6Digits(
                            props.lineHandling.result.lineHandlingNo
                          )}
                        </dd>
                      </span>
                      <span>
                        <dt className={classes.dt}>Depature Date: </dt>
                        <dd className={classes.dd}>{departureDate}</dd>
                      </span>
                      <span>
                        <dt className={classes.dt}>Status: </dt>
                        <dd className={classes.dd}>
                          {props.lineHandling.result.status === 3 && "Departed"}
                          {props.lineHandling.result.status === 4 && "Approved"}
                        </dd>
                      </span>
                    </div>
                  )}

                  {props.isMarineApproveLineHandlingAllowed && (
                    <PrimaryButton
                      className={classes.button}
                      disabled={props.activityLogs.isLoading || isLoading}
                      onClick={() => setShowConfirmModal(true)}
                      style={{ width: 208 }}
                    >
                      {isReadonly ? "Make changes" : "Approve"}
                    </PrimaryButton>
                  )}
                </div>
              </div>
            </div>
            <div className="ms-Grid-row">
              <div className="ms-Grid-col ms-md12">
                <div className={classes.stateRow}>
                  <div className={classes.stateButtons}>
                    {props.config &&
                      props.config.states
                        .filter(
                          (f) => f.name !== "..." && f.name !== "Departure"
                        )
                        .map((s) => (
                          <div
                            key={`review-state-${s.id}`}
                            className={
                              props.selectedState === s.name
                                ? classes.stateButtonSel
                                : classes.stateButton
                            }
                            onClick={() => props.setSelectedState(s.name)}
                          >
                            {s.name}
                          </div>
                        ))}
                  </div>
                  <Dropdown
                    options={nominationOptions}
                    onChange={onDropdownChanged}
                    onRenderOption={renderDropdown}
                    style={{ width: 208 }}
                    selectedKey={selectedNomination}
                  ></Dropdown>
                </div>
              </div>
            </div>
            <div className={clsx("ms-Grid-row", classes.columnHeader)}>
              <div className="ms-Grid-col ms-md6">Activity</div>
              <div className="ms-Grid-col ms-md3">Started On</div>
              <div className="ms-Grid-col ms-md3">Finished On</div>
            </div>
          </div>
        </div>
        <div className={clsx("custom-scroll", classes.lowerContainer)}>
          <div className="ms-Grid" dir="ltr">
            {groupedActivities
              .filter(
                (f) =>
                  f.nominationNo === selectedNomination &&
                  f.state === props.selectedState &&
                  f.endDescription !== undefined &&
                  f.endDescription !== ""
              )
              .map((activity: IActivity, index: number) => (
                <ReviewSoFItem
                  key={`row-${activity.endActivityId}-${index}`}
                  activity={activity}
                  readonly={isReadonly}
                  onUpdate={onEditTimestamp}
                />
              ))}
            {(isLoading ||
              props.activityLogs.isLoading ||
              props.lineHandling.isLoading) && <ApiSpinner />}

            {groupedActivities.filter(
              (f) =>
                f.nominationNo === selectedNomination &&
                f.state === props.selectedState &&
                f.endDescription !== undefined &&
                f.endDescription !== ""
            ).length === 0 && (
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-md12">
                  <Text className={classes.noItem} variant="small" block>
                    No activities in the current view
                  </Text>
                </div>
              </div>
            )}
          </div>
          {errMessage && (
            <div style={{ marginTop: "10px" }}>
              <MessageBar
                messageBarType={MessageBarType.error}
                onDismiss={() => closeErrDialog()}
              >
                {errMessage}
              </MessageBar>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default connect(
  (state: State) => ({
    ...state.activityLogs,
    ...state.general,
    ...state.lineHandling,
    ...state.processFlowConfigState,
    ...state.workPacket,
  }),
  {
    ...ActivityLogStore.actionCreators,
    ...LineHandlingStore.actionCreators,
    ...ProcessFlowConfigStore.actionCreators,
    ...WorkPacketeStore.actionCreators,
  }
)(ReviewSoF as any);

type IItemProps = {
  readonly: boolean;
  activity: IActivity;
  onUpdate(result: ActivityLog[]): void;
};

const ReviewSoFItem: FC<IItemProps> = (props: IItemProps) => {
  const { activity } = props;
  const [isError, setIsError] = useState(false);
  const [isEdited, setIsEdited] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [startedOnValue, setStartedOnValue] = useState(new Date());
  const [startedOnTimeValue, setStartedOnTimeValue] = useState<string>();
  const [finishedOnValue, setFinishedOnValue] = useState(new Date());
  const [finishedOnTimeValue, setFinishedOnTimeValue] = useState("");
  const maskFormat = {
    "1": /[0-2]/,
    "2": /[0-9]/,
    "3": /[0-5]/,
  };

  const getDateValue = (str: string) => {
    const local = moment.utc(`${str} UTC`).local();
    return local.toDate();
  };

  const getTimeValue = (str: string | undefined): string | undefined => {
    if (str) {
      const local = moment.utc(`${str} UTC`).local();
      return local.format("HH:mm");
    } else return undefined;
  };

  const onEditStartDate = async (date: Date | null | undefined) => {
    if (date) setStartedOnValue(date);
    if (!validateTimestamp(finishedOnTimeValue, startedOnTimeValue)) return;
    if (date) {
      let hour = 0,
        minute = 0;
      if (startedOnTimeValue && startedOnTimeValue.length === 5) {
        hour = parseInt(startedOnTimeValue.substr(0, 2));
        minute = parseInt(startedOnTimeValue.substr(3));

        date.setHours(hour);
        date.setMinutes(minute);
      }
      if (date > new Date()) {
        setErrorMessage("Start date and time must not be set in the future.");
        setIsError(true);
        addInvalidActivity(props.activity.startActivityId!);
        return;
      }

      let endDate = new Date(finishedOnValue);
      hour = parseInt(finishedOnTimeValue.substr(0, 2));
      minute = parseInt(finishedOnTimeValue.substr(3));
      if (hour > 23 || minute > 59) {
        setErrorMessage("Invalid date");
        setIsError(true);
        return;
      }

      endDate.setHours(hour);
      endDate.setMinutes(minute);

      if (date > endDate) {
        setErrorMessage("Start date must be earlier than end date.");
        addInvalidActivity(props.activity.order!);
        setIsError(true);
        return;
      }

      setIsError(false);
      removeInvalidActivity(props.activity.order!);
      await submitEditTimestamp(endDate.toISOString(), date.toISOString());
    }
  };

  const onEditStartedTime = async (_e: any, value?: string) => {
    if (value) value = value.replace("_", "");
    setStartedOnTimeValue(value);
    if (!validateTimestamp(finishedOnTimeValue, value)) {
      addInvalidActivity(props.activity.order!);
      return;
    }

    if (value) {
      let date = new Date(startedOnValue);
      let hour = parseInt(value.substr(0, 2));
      let minute = parseInt(value.substr(3));
      if (hour > 23 || minute > 59) {
        setErrorMessage("Invalid date");
        setIsError(true);
        addInvalidActivity(props.activity.order!);
        return;
      }
      date.setHours(hour);
      date.setMinutes(minute);
      if (date > new Date()) {
        setErrorMessage("Start date and time must not be set in the future.");
        setIsError(true);
        addInvalidActivity(props.activity.order!);
        return;
      }

      let endDate = new Date(finishedOnValue);
      hour = parseInt(finishedOnTimeValue.substr(0, 2));
      minute = parseInt(finishedOnTimeValue.substr(3));
      if (hour > 23 || minute > 59) {
        setErrorMessage("Invalid date");
        setIsError(true);
        addInvalidActivity(props.activity.order!);
        return;
      }
      endDate.setHours(hour);
      endDate.setMinutes(minute);

      if (date > endDate) {
        setIsError(true);
        setErrorMessage("Start date must be earlier than end date.");
        addInvalidActivity(props.activity.order!);
        return;
      }

      setIsError(false);
      removeInvalidActivity(props.activity.order!);
      await submitEditTimestamp(endDate.toISOString(), date.toISOString());
    }
  };

  const onEditFinishedDate = async (date: Date | null | undefined) => {
    if (date) setFinishedOnValue(date);
    if (!validateTimestamp(finishedOnTimeValue, startedOnTimeValue)) return;
    if (date) {
      date.setHours(parseInt(finishedOnTimeValue.substr(0, 2)));
      date.setMinutes(parseInt(finishedOnTimeValue.substr(3)));
      if (date > new Date()) {
        setErrorMessage("End date and time must not be set in the future.");
        addInvalidActivity(props.activity.order);
        setIsError(true);
        return;
      }

      if (startedOnTimeValue) {
        let startDate = new Date(startedOnValue);
        startDate.setHours(parseInt(startedOnTimeValue.substr(0, 2)));
        startDate.setMinutes(parseInt(startedOnTimeValue.substr(3)));

        if (startDate > date) {
          setIsError(true);
          addInvalidActivity(props.activity.order);
          setErrorMessage("Start date must be earlier than end date.");
          return;
        }

        setIsError(false);
        removeInvalidActivity(props.activity.order);
        await submitEditTimestamp(date.toISOString(), startDate.toISOString());
      } else {
        await submitEditTimestamp(date.toISOString());
      }
    }
  };

  const onEditFinishedTime = async (_e: any, value?: string) => {
    if (value) {
      value = value.replace("_", "");
      setFinishedOnTimeValue(value);
      if (!validateTimestamp(value, startedOnTimeValue)) {
        addInvalidActivity(props.activity.order);
        return;
      } else {
        removeInvalidActivity(props.activity.order);
      }
      let date = new Date(finishedOnValue);
      let hour = parseInt(value.substr(0, 2));
      let minute = parseInt(value.substr(3));
      if (hour > 23 || minute > 59) {
        setErrorMessage("Invalid date");
        setIsError(true);
        addInvalidActivity(props.activity.order);
        return;
      }
      date.setHours(hour);
      date.setMinutes(minute);
      if (date > new Date()) {
        setErrorMessage("End date and time must not be set in the future.");
        addInvalidActivity(props.activity.order);
        setIsError(true);
        return;
      }

      if (startedOnTimeValue) {
        let startDate = new Date(startedOnValue);
        hour = parseInt(startedOnTimeValue.substr(0, 2));
        minute = parseInt(startedOnTimeValue.substr(3));
        if (hour > 23 || minute > 59) {
          setErrorMessage("Invalid date");
          setIsError(true);
          addInvalidActivity(props.activity.order!);
          return;
        }
        startDate.setHours(hour);
        startDate.setMinutes(minute);

        if (startDate > date) {
          setErrorMessage("Start date must be earlier than end date.");
          addInvalidActivity(props.activity.order);
          setIsError(true);
          return;
        }

        setIsError(false);
        removeInvalidActivity(props.activity.order);
        await submitEditTimestamp(date.toISOString(), startDate.toISOString());
      } else {
        await submitEditTimestamp(date.toISOString());
      }
    }
  };

  const validateTimestamp = (end: string, start?: string): boolean => {
    var result =
      (start === undefined || start.length === 5) && end.length === 5;

    setIsError(!result);
    return result;
  };

  const submitEditTimestamp = async (
    finishedOn: string,
    startedOn?: string
  ) => {
    try {
      const payload = {
        startActivityId: props.activity.startActivityId,
        finishedActivityId: props.activity.endActivityId,
        startedOn,
        finishedOn,
      } as IEditTimestampModel;

      setIsLoading(true);
      const response = await Post(
        `/api/v1.5/linehandling/${activity.lineHandlingNo}/activities/timestamp`,
        JSON.stringify(payload)
      );
      setIsLoading(false);
      if (response.ok) {
        const result = (await response.json()) as ActivityLog[];

        setIsEdited(true);
        setIsError(false);

        props.onUpdate(result);
      } else {
        setIsError(true);
      }
    } catch {
      errMessage = "Unable to save changes. Please try to reconnect.";

      setIsLoading(false);
    }
  };

  const addInvalidActivity = (id: number) => {
    invalidActivities.push(id);
  };

  const removeInvalidActivity = (id: number) => {
    invalidActivities = invalidActivities.filter(
      (element) => ![id].includes(element)
    );
  };

  useEffect(() => {
    if (props.activity.startTime) {
      const local = moment(`${props.activity.startTime} UTC`).local();
      setStartedOnValue(local.toDate());
      setStartedOnTimeValue(local.format("HH:mm"));
    }

    const local = moment(`${props.activity.endTime} UTC`).local();
    setFinishedOnValue(local.toDate());
    setFinishedOnTimeValue(local.format("HH:mm"));
  }, [props.activity]);

  return (
    <div className={clsx("ms-Grid-row", classes.dataRow)}>
      <div className="ms-Grid-col ms-md6">{activity.endDescription}</div>
      <div className="ms-Grid-col ms-md3">
        {activity.startTime && (
          <div className={classes.inputGroup}>
            <DatePicker
              id={`txt-start-date-${activity.startActivityId}`}
              className={classes.inputField}
              textField={{
                inputClassName: clsx(
                  isError && !props.readonly
                    ? classes.textBoxError
                    : isEdited && !props.readonly
                    ? classes.textBoxEdited
                    : undefined
                ),
              }}
              formatDate={(val?: Date) => (val ? moment(val).format("ll") : "")}
              onSelectDate={onEditStartDate}
              disabled={isLoading || props.readonly}
              value={getDateValue(activity.startTime)}
              maxDate={new Date()}
            />
            <MaskedTextField
              id={`txt-start-time-${activity.startActivityId}`}
              className={classes.inputField}
              inputClassName={clsx(
                isError && !props.readonly
                  ? classes.textBoxError
                  : isEdited && !props.readonly
                  ? classes.textBoxEdited
                  : undefined
              )}
              mask="12:32"
              maskFormat={maskFormat}
              disabled={isLoading || props.readonly}
              onChange={onEditStartedTime}
              value={getTimeValue(activity.startTime)}
              style={{ width: 90 }}
              iconProps={{ iconName: "Clock" }}
            />
            {isError && (
              <Icon
                id={`icon-${activity.startActivityId}`}
                iconName="StatusErrorFull"
                className={classes.iconStyle}
              />
            )}
            {isLoading && <Spinner size={SpinnerSize.small} />}
          </div>
        )}
      </div>
      <div className="ms-Grid-col ms-md3">
        {activity.endTime && (
          <div className={classes.inputGroup}>
            <DatePicker
              id={`txt-end-date-${activity.endActivityId}`}
              className={classes.inputField}
              textField={{
                inputClassName: clsx(
                  isError && !props.readonly
                    ? classes.textBoxError
                    : isEdited && !props.readonly
                    ? classes.textBoxEdited
                    : undefined
                ),
              }}
              formatDate={(val?: Date) => (val ? moment(val).format("ll") : "")}
              onSelectDate={onEditFinishedDate}
              disabled={isLoading || props.readonly}
              value={getDateValue(activity.endTime)}
              maxDate={new Date()}
            />
            <MaskedTextField
              id={`txt-end-time-${activity.endActivityId}`}
              className={classes.inputField}
              inputClassName={clsx(
                isError && !props.readonly
                  ? classes.textBoxError
                  : isEdited && !props.readonly
                  ? classes.textBoxEdited
                  : undefined
              )}
              mask="12:32"
              maskFormat={maskFormat}
              disabled={isLoading || props.readonly}
              onChange={onEditFinishedTime}
              value={getTimeValue(activity.endTime)}
              style={{ width: 90 }}
              iconProps={{ iconName: "Clock" }}
            />
            {isError && (
              <Icon iconName="StatusErrorFull" className={classes.iconStyle} />
            )}
            {isLoading && <Spinner size={SpinnerSize.small} />}
          </div>
        )}
      </div>
      {errorMessage && (
        <TeachingBubble
          target={`#icon-${activity.startActivityId}`}
          onDismiss={() => setErrorMessage(undefined)}
        >
          {errorMessage}
        </TeachingBubble>
      )}
    </div>
  );
};
